module.exports = __webpack_public_path__ + "static/media/Push-Preview-Frame-Full.2cd60330.svg";